import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import NewsletterSignup from "@/components/NewsletterSignup";
import { CATEGORIES } from "@/lib/constants";

const Footer = () => {
  return (
    <footer className="bg-navy text-white mt-24" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="py-12 border-b border-white/10 grid lg:grid-cols-2 gap-8 items-center" data-testid="newsletter-band">
          <div>
            <p className="overline-label text-electric">Stay ahead</p>
            <h3 className="mt-2 font-display text-2xl font-extrabold">Subscribe to Lead ITES insights</h3>
            <p className="mt-2 text-white/60 text-sm max-w-md">
              Research, intelligence and opportunities for modern businesses — straight to your inbox.
            </p>
          </div>
          <NewsletterSignup />
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo light />
            <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-xs">
              Insights, intelligence and opportunities for modern businesses. Connecting technology,
              business and growth through media, research and qualified demand.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline-label text-electric">Topics</p>
            <ul className="mt-4 space-y-2.5">
              {CATEGORIES.slice(0, 6).map((c) => (
                <li key={c}>
                  <Link to={`/articles?category=${encodeURIComponent(c)}`}
                    className="text-white/70 hover:text-white text-sm transition-colors">{c}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline-label text-electric">Platform</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/reports" className="text-white/70 hover:text-white transition-colors">Research & Reports</Link></li>
              <li><Link to="/solutions" className="text-white/70 hover:text-white transition-colors">Business Solutions</Link></li>
              <li><Link to="/lead-generation" className="text-white/70 hover:text-white transition-colors">Lead Generation</Link></li>
              <li><Link to="/partnerships" className="text-white/70 hover:text-white transition-colors">Partnerships</Link></li>
              <li><Link to="/admin" className="text-white/70 hover:text-white transition-colors">Admin</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline-label text-electric">Company</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm">© {new Date().getFullYear()} Lead ITES. All rights reserved.</p>
          <p className="text-white/50 text-sm font-mono-plex">Connecting Technology, Business &amp; Growth.</p>
        </div>
        <p className="mt-6 text-center text-white/40 text-xs" data-testid="powered-by">
          Powered by LeadTech Connect Private Limited
        </p>
      </div>
    </footer>
  );
};

export default Footer;
